var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLPage"},[_c('div',{staticClass:"LLPage__breadcrumbs"},[_vm._t("breadcrumbs")],2),_c('div',{staticClass:"LLPage__container container"},[(_vm.slots.title)?_c('div',{staticClass:"LLPage__title"},[_vm._t("title")],2):_vm._e(),_c('div',{staticClass:"LLPage__content"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }